export default __webpack_public_path__ + "static/media/r200-5.62f07f85.png";